import React from 'react';
import cn from 'clsx';
import styles from './style.module.scss';
import { InfoField } from '@components-clean/core/info-field';

interface NoRecordsMessageProps {
    message: string;
    className?: string;
    onGrid?: boolean;
}

const NoRecordsMessage = ({ message, className, onGrid = false }: NoRecordsMessageProps) => {
    return (
        <div
            className={cn(
                'k-d-flex k-align-items-center k-justify-content-center opra-empty-grid-title-message',
                className,
                styles.emptyGridMessageContainer,
            )}
            data-on-grid={onGrid}
        >
            <InfoField type="Info" message={message} />
        </div>
    );
};

export default NoRecordsMessage;
